import React, { Component, Fragment } from "react";
import { injectIntl } from 'react-intl';
import API from '../../api/index'
var classNames = require('classnames');
import ReactTimeAgo from 'react-time-ago'
import { NotificationManager } from "Components/ReactNotifications";

import {
  logoutUser
} from "Redux/actions";
import { connect } from "react-redux";


import {
  Row,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  ModalFooter,
  Input
} from "reactstrap";


import NumberFormat from 'react-number-format';
import { Colxx, Separator } from "Components/CustomBootstrap";
import StateButton from "Components/StateButton";


class listProcess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      SearchPhrase: "",
      isRefreshing: false,
      isLoading: true,
      orders: [],
    };

    this.deleteOrderFromList = this.deleteOrderFromList.bind(this);
    this.deletingOrderFromList = this.deletingOrderFromList.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadData();
  }
  loadData(key) {
    API.order.lists.process.get()
      .then(data => {
        (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
        this.setState({
          orders: this.preprocessOrderData(data),
          isLoading: false,
          isRefreshing: false
        });
      })
      .catch(error => { });
  }
  preprocessOrderData(ordersData) {
    for (var i = 0; i < ordersData.length; i++) {
      ordersData[i].deleting = false;
    }
    return ordersData;
  }
  deleteOrderFromList(OrderId) {
    var tmpObj = this.state.orders;
    for (var i = 0; i < tmpObj.length; i++) {
      if (tmpObj[i].OrderId == OrderId) {
        tmpObj.splice(i, 1);
      }
    }
    this.setState({ orders: tmpObj });
  }
  deletingOrderFromList(OrderId) {

    var tmpObj = this.state.orders;
    for (var i = 0; i < tmpObj.length; i++) {
      if (tmpObj[i].OrderId == OrderId) {
        tmpObj[i].deleting = true;
      }
    }
    this.setState({ orders: tmpObj });
    setTimeout(() => {
      this.deleteOrderFromList(OrderId);
    }, 3000);
  }


  render() {

    return (
      this.state.isLoading ?
        <div className="loading"></div>
        :
        <Fragment>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Card>
                <CardBody>
                  <CardTitle>
                    <div className={"iconsminds-box-close headingicon"} />
                    صف سفارش‌های منتظر پردازش

                    <Button className={"default mb-1"} outline color={"info"} style={{ float: "left", border: "unset", width: "40px", borderRadius: 50, padding: "10px" }} onClick={() => { this.setState({ isRefreshing: true }); this.loadData(); }}>
                      <div className={" simple-icon-reload tableheadingicon"} />
                    </Button>


                    <div style={{ width: 200, float: "left", display: "inline-block", marginLeft: "10px", borderRadius: 50 }}>

                      <Input
                        autoComplete="off"
                        type="text"
                        name="SearchPhrase"
                        id="SearchPhrase"
                        color="info"
                        placeholder=""
                        value={this.state.SearchPhrase}
                        onChange={(e) => { this.setState({ SearchPhrase: e.target.value }); }}
                        style={{ borderRadius: "50px", padding: "9px", lineHeight: "29px", paddingBottom: "5px", paddingTop: "7px", paddingLeft: "35px", paddingRight: "19px" }}
                      />
                      <Button style={{ position: "absolute", top: 22, marginRight: "165px", marginTop: "11px", fontSize: 20, "padding": "5px", "color": "lightgray", "backgroundColor": "transparent", "border": "unset", "display": ((this.state.SearchPhrase != "")) ? "block" : "none" }} onClick={(e) => { this.setState({ SearchPhrase: "" }); }}>
                        <i className="simple-icon-close"></i>
                      </Button>
                    </div>
                  </CardTitle>
                  {!this.state.isRefreshing ?
                    <div className="table-responsive">

                      <table className="table table-hover order-table">
                        <thead>
                          <tr>
                            <th>شماره سفارش</th>
                            <th>زمان ثبت</th>
                            <th> <div className={" iconsminds-down arrowsorticon"} />زمان پرداخت</th>
                            <th>موبایل</th>
                            <th>نام مشتری </th>
                            <th>مبلغ سفارش </th>
                            <th>نوع سفارش</th>
                            <th>نحوه پرداخت</th>
                            <th><a title="سفارش توضیح عمومی دارد؟" className={" glyph-icon  simple-icon-flag tableheadingicon"} /></th>
                            <th><a title="سفارش توضیح مخفی دارد؟" className={" glyph-icon simple-icon-ghost  tableheadingicon"} /></th>
                            <th><a title="سفارش توضیح مشتری دارد؟" className={" glyph-icon simple-icon-info  tableheadingicon"} /></th>
                            <th><a title="سفارش تحویل حضوری است؟" className={" iconsminds-shop-2 tableheadingicon"} /></th>
                            <th>اپراتور</th>
                            <th>عملیات‌</th>
                          </tr>

                        </thead>

                        {this.state.orders.filter((row => {
                          return (this.state.SearchPhrase.trim() == "") ? true :
                            (
                              row.CustomerMobile.indexOf(this.state.SearchPhrase) > -1 ||
                              (row.OrderId + "").indexOf(this.state.SearchPhrase) > -1 ||
                              row.CustomerFullName.indexOf(this.state.SearchPhrase) > -1 ||
                              row.Payable.indexOf(this.state.SearchPhrase) > -1 ||
                              row.OrderType.indexOf(this.state.SearchPhrase) > -1 ||
                              row.OperatorName.indexOf(this.state.SearchPhrase) > -1 ||
                              ({ SITE: "درگاه", CARD: "کارت", CASH: "نقد", POS: "پوز" }[row.PaymentType].indexOf(this.state.SearchPhrase) > -1)
                            );
                        })).map(row => (
                          <TableBodyRows
                            key={row.OrderId}
                            data={row}
                            deletingOrderFromList={this.deletingOrderFromList}
                          />
                        ))}
                      </table>
                    </div>
                    : <div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>}
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        </Fragment>
    );
  }
}

class TableBodyRows extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      clicked: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleProcessButtonClick = this.handleProcessButtonClick.bind(this);
    this.handleCancleButtonClick = this.handleCancleButtonClick.bind(this);
  }
  handleProcessButtonClick() {
    return new Promise((success, fail, $this) => {

      this.setState({ clicked: true });

      API.order.lists.process.record({ OrderId: this.props.data.OrderId })
        .then(data => {
          (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

          if (data.ERRORS !== undefined) {
            fail("خطا در ثبت پردازش");
            for (var i = 0; i < data.ERRORS.length; i++) {
              setTimeout(function (err) {
                NotificationManager.error(
                  err,
                  "خطا در ثبت پردازش",
                  8000, null, null, "filled");
              }, (i + 1) * 700, data.ERRORS[i]);
              this.setState({
                clicked: false
              });
            }
          } else {
            success("پردازش ثبت شد");
            setTimeout(() => {
              this.props.deletingOrderFromList(this.props.data.OrderId);
              this.setState({ clicked: false, modal: false });
            }, 1000);
          }

        })
        .catch(error => {
          fail("خطا در ثبت پردازش");
        });
    });


  }
  handleCancleButtonClick() {
    return new Promise((success, fail, $this) => {
      if (confirm('آیا از کنسل کردن این سفارش اطمینان کامل دارید؟')) {
        this.setState({ clicked: true });

        API.order.cancle({ OrderId: this.props.data.OrderId })
          .then(data => {
            (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

            if (data.ERRORS !== undefined) {
              fail("خطا در ثبت کنسلی");
              for (var i = 0; i < data.ERRORS.length; i++) {
                setTimeout(function (err) {
                  NotificationManager.error(
                    err,
                    "خطا در ثبت کنسلی",
                    8000, null, null, "filled");
                }, (i + 1) * 700, data.ERRORS[i]);
                this.setState({
                  clicked: false
                });
              }
            } else {
              success("کنسلی ثبت شد");
              setTimeout(() => {
                this.props.deletingOrderFromList(this.props.data.OrderId);
                this.setState({ clicked: false, modal: false });
              }, 1000);
            }

          })
          .catch(error => {
            fail("خطا در ثبت کنسلی");
          });
      } else {
        fail("خطا در ثبت کنسلی");
      }
    });


  }
  toggle() {
    if (this.state.clicked) { return; }
    this.setState({
      modal: !this.state.modal
    });
  }
  render() {
    const {
      data: { OrderId, OpenedAt, PaymentAt, CustomerMobile, CustomerFullName, Payable, OrderType, DeliveryInPerson, PaymentType, NotePublic, NotePrivate,NoteCustomer, OperatorName, deleting },

    } = this.props;
    var hasPublicNote = (NotePublic !== null && NotePublic.trim().length > 0) ? "✓" : "-";
    var hasPrivateNote = (NotePrivate !== null && NotePrivate.trim().length > 0) ? "✓" : "-";
    var hasCustomerNote = (NoteCustomer !== null && NoteCustomer.trim().length > 0) ? "✓" : "-";
    var deletingClass = (deleting) ? " deleting-row " : "";
    var OrderTypesFa = { SHOP: "حضوری", SITE: "سایت", CHAT: "چت" };
    var PaymentsTypesFa = { SITE: "درگاه", CARD: "کارت", CASH: "نقد", POS: "پوز" };

    return (
      <tbody className={deletingClass}>
        <tr className={"order-spacer"}>

        </tr>
        <tr className={"order-item"}>


          <td><a href={"/app/orders/view-order/" + OrderId}> {OrderId} <div className={" simple-icon-arrow-left-circle icongotoorder"} /></a></td>
          <td className={"text-muted"}><ReactTimeAgo date={Date.parse(OpenedAt)} timeStyle="round-minute" locale="en" /></td>
          <td className={"text-muted"}><ReactTimeAgo date={Date.parse(PaymentAt)} timeStyle="round-minute" locale="en" /></td>

          <td><a href={"/app/customers/view-customer/" + CustomerMobile} target="_blank"> {CustomerMobile} <div className={" simple-icon-arrow-left-circle icongotoorder"} /></a></td>
          <td><div className={classNames({
           
            "text-muted": true,
            "simple-icon-options": (CustomerFullName.trim() == "")
          })} />{CustomerFullName}</td>
          <td className={"text-muted"}>
            <NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={'text'} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div >{value}</div>} />
          </td>
          <td className={"text-muted"}>{OrderTypesFa[OrderType]}</td>
          <td className={"text-muted"}>{PaymentsTypesFa[PaymentType]}</td>

          <td className={"text-muted"}>{hasPublicNote}</td>
          <td className={"text-muted"}>{hasPrivateNote}</td>
          <td className={"text-muted"}>{hasCustomerNote}</td>
          <td className={"text-muted"}>
            <div className={
              classNames({
                "simple-icon-check": (DeliveryInPerson === true),
                "text-muted": true
              })}
              />
              {classNames({
                "-": (DeliveryInPerson === false)
              })}
          </td>
          <td className={"text-muted"}>{OperatorName}</td>
          <td className={"text-muted"}>
            <Button className={"default md-2"} outline color={"info"} disabled={deleting} onClick={() => { this.setState({ modal: true }); }}>
              ثبت پردازش
            </Button>
            <Modal isOpen={this.state.modal} toggle={this.toggle}>
              <ModalHeader toggle={this.toggle}>
                ثبت پردازش برای سفارش #{OrderId}
              </ModalHeader>
              <ModalBody>


                <table>

                  <tbody>
                    <tr>
                      <th>شماره سفارش:</th>
                      <td>{OrderId}</td>
                    </tr>
                    <tr>
                      <th>موبایل مشتری:</th>
                      <td>{CustomerMobile}</td>
                    </tr>
                    <tr>
                      <th>نام مشتری:</th>
                      <td>{CustomerFullName}</td>
                    </tr>
                    <tr>
                      <th>مبلغ سفارش:</th>
                      <td><NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={'text'} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div >{value}</div>} /></td>
                    </tr>

                  </tbody>
                </table>

              </ModalBody>
              <ModalFooter>
                <StateButton
                  disabled={this.state.clicked}
                  id="processButton"
                  OrderId={OrderId}
                  color="primary"
                  className="mb-3 default"
                  onClick={this.handleProcessButtonClick}
                >
                  سفارش تحویل شد
                </StateButton>
                <StateButton
                  disabled={this.state.clicked}
                  id="cancleButton"
                  OrderId={OrderId}
                  color="danger"
                  className="mb-3 default"
                  onClick={this.handleCancleButtonClick}
                >
                  سفارش کنسل شد
                </StateButton>

              </ModalFooter>
            </Modal>
          </td>
        </tr>

      </tbody>
    );
  }
}

const mapStateToProps = ({ menu, settings }) => {
  return { logoutUser };
};
export default injectIntl(connect(
  mapStateToProps,
  { logoutUser }
)(listProcess));
// export default injectIntl(listProcess);